// Device location for the context add-on when deviceLocation is OPTIONAL or
// REQUIRED (PLAN-Device-Context.md §B4.6).
//
// Must be called synchronously inside the "Comenzar verificación" click:
// iOS Safari only shows the permission prompt from a user gesture. The Promise
// executor runs synchronously, so getCurrentPosition is invoked before the
// caller's first await.

export interface LocationReport {
  permission: 'granted' | 'denied' | 'unavailable' | 'timeout';
  lat?: number;
  lon?: number;
  accuracy?: number;
  timestamp?: number;
}

export function requestPosition(): Promise<LocationReport> {
  return new Promise((resolve) => {
    if (!('geolocation' in navigator)) {
      resolve({ permission: 'unavailable' });
      return;
    }
    navigator.geolocation.getCurrentPosition(
      (p) =>
        resolve({
          permission: 'granted',
          lat: p.coords.latitude,
          lon: p.coords.longitude,
          accuracy: p.coords.accuracy,
          timestamp: Math.round(p.timestamp),
        }),
      (err) =>
        resolve({
          permission: err.code === err.PERMISSION_DENIED ? 'denied' : err.code === err.TIMEOUT ? 'timeout' : 'unavailable',
        }),
      { enableHighAccuracy: true, timeout: 10000, maximumAge: 60000 },
    );
  });
}
